/**
 * Empty stand-in for Next.js's unconditional `polyfill-module`.
 * Safe for our modern browserslist (Chrome/Edge/Firefox 120+, Safari 17+).
 * Removes ~14 KiB of legacy polyfills flagged by Lighthouse.
 */
export {};
